export const DELETE_THEMES_MUTATION = `
  mutation DeleteThemes ($ids: [Int!]!) {
    deleteThemes (ids: $ids)
  }
`;

export type DeleteThemesResponseType = {
  deleteTheme: Array<number>
}
